import React, { useState } from 'react';
import Stats from 'three/examples/jsm/libs/stats.module.js';

import { StandardFloatingBox } from './common/StandardFloatingBox';

export let stats: Stats | undefined;

if (!process.env.PRODUCTION) {
  // this block is intentional to allow the bundler to tree-shake the stats module during production builds
  stats = new Stats();

  // The stats panel is positioned absolutely. Reset those styles, so it'll render within this box.
  stats.dom.style.position = '';
  stats.dom.style.top = '';
  stats.dom.style.left = '';

  stats.showPanel(0);
}

function addStatsToContainer(container: HTMLDivElement | null) {
  if (container && stats) {
    container.replaceChildren(stats.dom);
  }
}

export function PerformanceStatisticsFloatingBox() {
  const [visible, setVisible] = useState(true);

  if (!visible || stats == null) return null;

  return (
    <StandardFloatingBox sx={{ width: '80px', padding: 0 }}>
      <div
        ref={addStatsToContainer}
        onContextMenu={(event) => {
          event.preventDefault();
          setVisible(false);
        }}
      />
    </StandardFloatingBox>
  );
}
